import { render } from "./PresentHome.vue?vue&type=template&id=830f2524&scoped=true&lang=html"
import script from "./PresentHome.vue?vue&type=script&lang=js"
export * from "./PresentHome.vue?vue&type=script&lang=js"

import "./PresentHome.vue?vue&type=style&index=0&id=830f2524&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830f2524"]])

export default __exports__